import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import Table from "../../Components/Sales/Table";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import EditLead from "../../Components/Sales/EditLead";
import VisitsSummary from "../../Components/Sales/VisitsSummary";
import { toast } from "react-toastify";

import { useSelector } from "react-redux";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import LinkUnlink from "../../Components/Sales/LinkUnlink";
import ViewLead from "../../Components/Sales/ViewLead";
import AssignStaff from "../../Components/Sales/AssignStaff";
import SideModal from "../../Components/SideModal";
import DeleteLead from "../../Components/Sales/DeleteLead";

const VisitLeads = () => {
  const navigate = useNavigate();

  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const { t, i18n } = useTranslation();
  const [isShowEditLead, setIsShowEditLead] = useState(false);
  const [isShowDeleteLead, setIsShowDeleteLead] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  const [viewDetail, setViewDetail] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("VS");
  const [masterData, setMasterData] = useState();
  const [linkProperty, setLinkProperty] = useState(false);
  const [isAssignStaff, setIsAssignStaff] = useState(false);
  const [apiData, setApiData] = useState();
  const [staffList, setStaffList] = useState();
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [summary, setSummary] = useState({
    totalLeads: 0,
    newLeads: 0,
    followUpLeads: 0,
    visitedLeads: 0,
    convertedLeads: 0,
  });
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const [startDate, setStartDate] = useState(
    moment().subtract(1, "year").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const propertyList = useSelector((state) => state.PropertyReducer.property);

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  //"VS"
  const query = `&startDate=${startDate}&endDate=${endDate}&propId=${property?.id}&s=${searchQuery}&t=${filterType}&filter=${filter}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/lead/list/web?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      setSummary(res?.summary);
      setMasterData(res?.data);
      setStaffList(res?.staffList);
      setIsFocused(true);
    }
  };

  const getError = (res) => {
    navigate("/no-access");
  };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);

    return () => clearTimeout(handler);
  }, [
    property?.id,
    startDate,
    endDate,
    filter,
    filterType,
    searchQuery,
  ]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleLeadsClose = () => {
    setIsShowEditLead(false);
  };

  //------- Edit Lead -------
  const editLeadFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/lead/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsShowEditLead(false);
      setViewDetail(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editLeadLoading, mutate: editLeadMutate } = useMutation(
    editLeadFunction,
    {
      onSuccess: onEditLeadSuccess,
      onError: onEditLeadError,
    }
  );

  const onSummaryBoxClick = (data) => {
    const today = moment().startOf("day");
    let filteredData;
    if (data === "TVS") {
      filteredData = masterData.filter((lead) => {
        if (!lead.visitDateTime) return false;
        return moment(lead.visitDateTime).isSame(today, "day");
      });
    } else if (data === "UVS") {
      filteredData = masterData.filter((lead) => {
        if (!lead.visitDateTime) return false;
        return moment(lead.visitDateTime).isAfter(today, "day");
      });
    }
    else filteredData = masterData;
    setApiData(filteredData);
    //setFilter(data);
  };

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  //------- Link Property Lead -------
  const linkPropertyLeadFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/lead/link/unlink/property`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const onLinkPropertyeLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onLinkPropertyLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: linkPropertyLoading, mutate: linkPropertyMutate } =
    useMutation(linkPropertyLeadFunction, {
      onSuccess: onLinkPropertyeLeadSuccess,
      onError: onLinkPropertyLeadError,
    });

  //------- Link Staff Lead -------
  const assignStaffLeadFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/lead/link/unlink/staff`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onAssignStaffLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onAssignStaffLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: assignStaffLoading, mutate: assignStaffMutate } =
    useMutation(assignStaffLeadFunction, {
      onSuccess: onAssignStaffLeadSuccess,
      onError: onAssignStaffLeadError,
    });

  //------- Delete Lead -------
  const deleteLeadFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/lead/remove`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onDeleteLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsShowDeleteLead(false);
    } else {
      setIsShowDeleteLead(false);
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeleteLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteLeadLoading, mutate: deleteLeadMutate } = useMutation(
    deleteLeadFunction,
    {
      onSuccess: onDeleteLeadSuccess,
      onError: onDeleteLeadError,
    }
  );
  const handleDeleteClose = () => {
    setIsShowDeleteLead(false);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Visits
          <Underline />
        </BoxTitle>
        {/* <Filters
          submitHandler={submitHandler}
          initialValues={initialValues}
          // InitialLoading={getDashboardLoading}
          setKey={setKey}
          setIsShowAddLead={setIsShowAddLead}
          user={user}
        /> */}
      </BoxHead>

      <SideModal
        isOpen={linkProperty}
        onClose={() => setLinkProperty(false)}
      >
        <LinkUnlink
          setLinkProperty={setLinkProperty}
          linkProperty={linkProperty}
          linkPropertyLoading={linkPropertyLoading}
          linkPropertyMutate={linkPropertyMutate}
          property={propertyList}
          selectedData={selectedData}
        />
      </SideModal>

      <SideModal
        isOpen={isAssignStaff}
        onClose={() => setIsAssignStaff(false)}
      >
        <AssignStaff
          setIsAssignStaff={setIsAssignStaff}
          isAssignStaff={isAssignStaff}
          assignStaffLoading={assignStaffLoading}
          assignStaffMutate={assignStaffMutate}
          staffList={staffList}
          selectedData={selectedData}
        />
      </SideModal>

      <SideModal
        isOpen={viewDetail}
        onClose={() => setViewDetail(false)}
      >
        <ViewLead
          setViewDetail={setViewDetail}
          setSelectedData={setSelectedData}
          selectedData={selectedData}
          setIsShowEditLead={setIsShowEditLead}
          setIsShowDeleteLead={setIsShowDeleteLead}
        />
      </SideModal>

      <SideModal
        isOpen={isShowEditLead}
        onClose={() => setIsShowEditLead(false)}
      >
        <EditLead
          editLeadLoading={editLeadLoading}
          editLeadMutate={editLeadMutate}
          handleClose={handleLeadsClose}
          selectedData={selectedData}
          setViewDetail={setViewDetail}
        />
      </SideModal>

      {isShowDeleteLead && (
        <DeleteLead
          setIsShowDeleteLead={setIsShowDeleteLead}
          isShowDeleteLead={isShowDeleteLead}
          deleteLeadLoading={deleteLeadLoading}
          deleteLeadMutate={deleteLeadMutate}
          selectedData={selectedData}
          handleClose={handleDeleteClose}
        />
      )}

      {(isLoading || isRefetching) && !isFocused && (
        <SummarySkeletonLoading count={3} />
      )}
      {isFocused && summary && (
        <>
          <VisitsSummary summaryData={summary} onClick={onSummaryBoxClick} />
          <FilterTableWrapper>
            <FilterWrapper>
              <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                <SearchFilterBox
                  options={searchOptions}
                  handleFilterChange={handleFilterChange}
                  handleClearFilters={handleClearFilters}
                />
                <DateRange
                  submitHandler={submitHandler}
                  defaultLabel={
                    moment(startDate).format("DD MMM yyyy") +
                    " - " +
                    moment(endDate).format("DD MMM yyyy")
                  }
                />
              </div>
              {/* <DownloadBtn type="button" onClick={() => downloadReport()}>
    {isDownloading ? "Downloading..." : "Download"}
  </DownloadBtn> */}
            </FilterWrapper>
            {!error && !isLoading && data && (
              <TableWrapper>
                <Table
                  apiData={error ? [] : apiData}
                  setSelectedData={setSelectedData}
                  setIsShowEditLead={setIsShowEditLead}
                  setLinkProperty={setLinkProperty}
                  setViewDetail={setViewDetail}
                  setIsAssignStaff={setIsAssignStaff}
                />
                {(error || apiData.length === 0) && !isLoading && (
                  <NotFoundModel msg={"No new leads at the moment."} />
                )}
              </TableWrapper>
            )}
          </FilterTableWrapper>
        </>
      )}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 lg:gap-0 md:flex md:space-x-4 items-end mt-0 md:mt-0`;

export default VisitLeads;
